import React from "react";
import { useHistory } from "react-router";
import { Images } from "../../../Assets/0a-exporter";
import "./success-modal.style.scss";
export default function SuccessModal({ closeIt }) {
  const history = useHistory();
  return (
    <div className="success-modal-wrapper">
      <div className="success-modal">
        <button onClick={() => closeIt()} className="close-button">
          x
        </button>
        <h4>Congrats! Profile is created successfully</h4>
        <img src={Images.success} />
        <p>You are almost there! Apply for job and get offers</p>
        <button
          onClick={() => history.push("/user/profile")}
          className="ok-button"
        >
          Ok
        </button>
      </div>
    </div>
  );
}
